<template>
  <div id="main_container">
    <div id="disclaimer">
      <h3 id="disclaimer_header">Disclaimer</h3>
      <div id="disclaimer_text">

      </div>
      <form>
        <input id="acceptButton" type="button" value="" class="form_button_submit">
      </form>
      <br class="clearfix"/>
    </div>
    <div id="preselection">
      <div class="halfRow" v-on:click="clickMedium('water')">
        <img src="../assets/gfps-pt-diagram-selection-utility.jpg" alt="utility"/>
        <div class="preselectBox">
          <h2><span id="app_water">Versorgung</span></h2>
          <p id="app_water_sub">
            Lorem ipsum dolor sit amet.
            <br>
            Cum sociis natoque penatibus.
          </p>
          <a href="#" class="continueButton">Continue</a>
        </div>
      </div>
      <div class="halfRow" v-on:click="clickMedium('industrial')">
        <img src="../assets/gfps-pt-diagram-selection-industry.jpg" alt="utility"/>
        <div class="preselectBox">
          <h2><span id="app_industrial">Versorgung</span></h2>
          <p id="app_industrial_sub">
            Lorem ipsum dolor sit amet.
            <br>
            Cum sociis natoque penatibus.
          </p>
          <a href="#" class="continueButton">Continue</a>
        </div>
      </div>
      <div class="halfRow" v-on:click="clickMedium('gas')">
        <img src="../assets/gfps-pt-diagram-selection-gas.jpg" alt="utility"/>
        <div class="preselectBox">
          <h2><span id="app_gas">Versorgung</span></h2>
          <p id="app_gas_sub">
            Lorem ipsum dolor sit amet.
            <br>
            Cum sociis natoque penatibus.
          </p>
          <a href="#" class="continueButton">Continue</a>
        </div>
      </div>

      <br class="clearfix"/>
    </div>
    <div id="wrapper">


      <a id="back_to_app_selection" class="link left back_to_app_selection">Zurück zur Anwendungsauswahl</a>
      <h2 id="app_header"></h2>
      <br class="clearfix"/>
      <div class="innerWrapper">
        <div class="halfRow">
          <!--      <h2><translate>Valve Information</translate></h2>-->
          <div class="myblock">
            <div class="myLabel">
              <span><label for="selectUnits"><span id="units"></span></label></span>
              <span class="infoI hidePrint" id="tooltipValve" v-tooltip="{content:asyncContent,loadingContent: '<i>Loading...</i>',}">&nbsp;</span>
            </div>
            <div class="row ">

              <Multiselect id="selectUnits" class="selectUnits" ref="selectUnits" @changeSelect="convertValues"></Multiselect>
            </div>
          </div>

          <div class="myblock">
            <div class="myLabel">
              <span><label for="selectPipeMat"><span id="materials"></span></label></span>
            </div>
            <div class="row ">
              <select id="selectPipeMat" multiple="multiple"></select>
              <!--          <Multiselect class="valve" ref="selectvalve" @changeSelect="globalreInit"></Multiselect>-->
            </div>
          </div>

        </div>

        <div class="halfRow" style="position:relative">
          <div class="myblock">
            <div class="myLabel">
              <span><label for="inputTemp"><span id="temperature"></span></label></span>
            </div>
            <div class="row ">
              <div class="inputWrapper">
                <input name="inputTemp" value="" id="inputTemp" type="number" step=".1"/>
              </div>
            </div>
          </div>

          <div class="myblock">
            <div class="myLabel">
              <span><label for="inputPressure"><span id="pressure"></span></label></span>
            </div>
            <div class="row ">
              <div class="inputWrapper">
                <input name="inputPressure" value="" id="inputPressure" type="number" step=".1"/>
              </div>
            </div>
          </div>
          <div class="flLeft linked" id="linkedIcon">
            <img id="linkicon_linked" style="display: none" :src="getImgUrl('linked.fw.png')"/>
            <img id="linkicon_unlinked" :src="getImgUrl('unlinked.fw.png')"/>
          </div>

        </div>

        <div class="halfRow">
          <div class="myblock">
            <div class="myLabel">
              <span><label for="inputDF"><span id="design_factor"></span></label></span>
            </div>
            <div class="row ">
              <div class="inputWrapper">
                <input type="text" name="inputDF" value="1.25" id="inputDF" readonly="readonly" class="unselectable"/>
              </div>
            </div>
          </div>

          <div class="myblock">
            <div class="myLabel">
              <span><label for="selectDuration"><span id="duration"></span></label></span>
            </div>
            <div class="row ">
              <Multiselect id="selectDuration" class="selectDuration" ref="selectDuration" @changeSelect="selectDuration"></Multiselect>
              <!--            <select name="selectDuration" id="selectDuration">-->
              <!--            </select>-->
            </div>
          </div>
        </div>
        <br class="clearfix"/>

        <div class="settings" id="upperSettingsBlock">

        </div>
        <div id="buttonBox">
          <div class="arrow hidePrint" style="margin-left: -6px;">
            <span id="printButton" class="bImage" >Print</span>
          </div>
          <div class="arrow hidePrint" style="margin-left: -6px;">
            <span id="emailButton" class="bImage" >E-Mail</span>
          </div>
          <br class="clearfix"/>
        </div>
        <div id="containerSW"></div>
        <div id="hint_graphs"></div>
        <br class="clearfix"/>

        <div id="graph_description">Lorem Ipsum</div>
        <br>
        <!--      <a id="back_to_app_selection_mobile" class="link left back_to_app_selection">Zurück zur Anwendungsauswahl</a>-->
      </div>

    </div>

    <div style="display: none">

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import bowser from "bowser"
import Multiselect from "@/components/multi_select";
import classList from "@/assets/classList.min.js";

window.bowser = bowser;
var loadScript = function (src, callback) {
  var s,
      r,
      t;
  r = false;
  s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.onload = s.onreadystatechange = function () {
    if (!r && (!this.readyState || this.readyState == 'complete'))
    {
      r = true;
      callback();
    }
  };
  t = document.getElementsByTagName('script')[0];
  t.parentNode.insertBefore(s, t);
};

var options;

var chart, medData = [], pData = [], selMats, units = 'metric', paper, medium, bTip, $texts, lang, duration = 25, linked = false, firstStart = true;
var serverURL = "https://www.gfpstools.com/pt-diagram2015/";
// serverURL = "https://beta.ad-lantis.de/_pttool-2015/";
// serverURL = "https://www.gfpstools.com/pt-diagram2015/";
var $matGroup, $mat, $p, iid;

export default {
  name: "PtDiagram",
  props: ['myvm'],
  components: {Multiselect},
  created: function () {
  },
  beforeCreate: function () {
    this.$nextTick(function () {
      var that = this;
      var assetsDir = process.env.NODE_ENV === 'production'
          // ? '/flange_tool/vueChemresTool/com/en/downloads-tools/online-tools/'
          ? '/content/dam/gfps/com/website-tools/pt-tool-vue3/js/'
          : '';
      window.browser = bowser.name.toLowerCase();
      window.bowser = bowser;
      // //console.log("bowser", bowser);
      // //console.log("bowser iPhone", bowser.iPhone);
      function jqready()
      {
        loadScript(assetsDir + "jquery-ui.js", juiready);
      }

      function juiready()
      {
        loadScript(assetsDir + "jquery.multiselect.js", ms1ready);
      }

      function ms1ready()
      {
        loadScript(assetsDir + "jquery.multiselect.filter.js", ms2ready);
      }

      function ms2ready()
      {
        loadScript(assetsDir + "highcharts.js", ttready);
      }
      function ttready()
      {
        loadScript(assetsDir + "tooltipsy.min.js", hsready);
      }
      function hsready()
      {
        that.preInit();
      }
      // loadScript(assetsDir + "jquery-2.2.4.min.js", jqready);
      loadScript( "//ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js", jqready);
    })
  },
  methods: {
    loadTextData: function () {
      //console.log("loadTextData" );
      var that = this;

      $.get(serverURL + 'data/texts.php?lang=' + lang, function (xml) {
        $texts = $(xml);
        $texts.children().children().each(function (i, el) {
          $('#' + el.tagName).html($(el).text());
        });
        $('input[name=inputDF]').val(that.getText('hint_design_factor'));
        $('#printButton').val(that.getText('print_button_text'));
        $('#emailButton').val(that.getText('email_button_text'));
        $('#acceptButton').val(that.getText('accept_button_text'));
        $('.back_to_app_selection').text(that.getText('back_to_app_selection'));
        $('#temperature').text(that.getText('temperature') + (units == 'metric' ? ' [°C]' : ' [°F]'));
        $('#pressure').text(that.getText('pressure') + (units == 'metric' ? ' [bar]' : ' [psi]'));
        $('title').text(that.getText('app_title'));
        $(".continueButton").text(that.getText('continue_button_text'));
        var yearsAr = [5, 10, 15, 25];
        var opts = [];
        for (var i = 0; i < yearsAr.length; i++)
        {
          opts.push({value:yearsAr[i], label:yearsAr[i] + ' ' + that.getText('years')});
        }
        // that.$refs.selectDuration.setOptions(opts);
        that.$refs.selectUnits.setOptions([{value:"metric", label:that.getText("metric")}, {value:"imperial", label:that.getText("imperial")}]);
        // $('#selectDuration').val(duration);
        if (that.getURLParameter('u'))
        {
          units = that.getURLParameter('u');
          console.log("UNITS###", units);
          that.$refs.selectUnits.setSelected(units);
          // $("#selectUnits").val(units);
        }
        that.$refs.selectDuration.setSelected(duration);
        // if (that.getURLParameter('e'))
        //   window.parent.setTexts({
        //     header: that.getText('branding_header'),
        //     copytext: that.getText('branding_copytext')
        //   });
        if (that.getURLParameter('print'))
          that.loadPipeData();
        else
          $('#disclaimer').fadeIn(200);
      });
    },
    preInit: function () {
      var that = this;
      var theHeader = $("header");
      $("header").remove();
      $("body").prepend(theHeader);
      if($("window").width() > 670) $("main").css("margin-top", "134px");
      options = {
        chart: {
          renderTo: 'containerSW',
          type: 'area',
          height:700,
          animation: false,
          events: {
            click: function (event)
            {

              $('#inputTemp').val(chart.xAxis[0].toValue(event.chartX).toFixed(1));
              $('#inputPressure').val(chart.yAxis[0].toValue(event.chartY).toFixed(1));
              that.showHideSeries(event.pageX, event.pageY);
              that.setClickMarker();
            }
          },
          ignoreHiddenSeries: false,
          spacingTop: 30,
        },
        title: {
          text: null
        },
        legend: {
          // layout: $(window).width() <= 700?'horizontal':'vertical',
          layout: 'horizontal',
          align: 'left',
          verticalAlign: 'top',
          alignColumns:false,
          // x: -1370,
          //  y: $(window).width() <= 700?-100:0,
          floating: false,
          borderWidth: 0,
          margin:$(window).width()<600?26:18,
          // itemWidth:100,
          symbolHeight:40,
          symbolWidth:60,
          itemMarginBottom:28,//12,
          itemMarginTop:28,
          navigation: {enabled:false, arrowSize:15},
          // lineHeight:80,
          // useHTML : true,
          backgroundColor: 0,//(Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
          itemStyle: {
            fontFamily: 'DINNextLTW05-Regular',
            // fontFamily: 'DINNextLTW05-Regular,Arial, Helvetica, sans-serif',
            fontSize: 15,
            color: '#000',
            verticalAlign: 'top',
            // width:100,
          }
        },
        xAxis: {
          title: {
            align: 'high',
            style: {
              fontFamily: 'Arial, Helvetica, sans-serif'
            }
          },
          labels: {
            style: {
              fontFamily: 'Arial, Helvetica, sans-serif'
            }
          },
          minorTickInterval: 5,
          tickInterval: 10
        },
        yAxis: {
          title: {
            align: 'high',
            rotation: 0,
            style: {
              fontFamily: 'Arial, Helvetica, sans-serif'
            },
            offset: 10
          },
          labels: {
            style: {
              fontFamily: 'Arial, Helvetica, sans-serif'
            }
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }],
          tickWidth: 1,
          tickInterval: 2,
          minorTickInterval: 1
        },
        tooltip: {
          enabled: true,
          formatter: function ()
          {
            return '<b>' + this.series.name + '</b>';
          },
          snap: 1,
          style: {
            fontFamily: 'Arial, Helvetica, sans-serif'
          }
        },
        plotOptions: {
          series: {
            animation: false,
            point: {
              events: {
                click: function (event)
                {
                  var pos = $('#containerSW').position();
                  var gridPos = that.getGridTopLeft();
                  // console.log("##pos", pos);
                  // console.log("##gridpos", gridpos);

                  that.showHideSeries(pos.left + gridPos.x + event.target.plotX, pos.top + gridPos.y +
                      event.target.plotY);
                  that.setClickMarker();
                }
              }
            }
          },
          area: {
            events: {
              click: function (event)
              {
                //console.log('areaEvent', event);
              }
            },
            fillOpacity: 0
          },
          line: {
            events: {
              click: null
            },
            enableMouseTracking: false
          }
        },
        credits: {
          enabled: false
        }
      };
      this.init();
    },
    init: function () {
      //console.log("init" );
        /**
         * Highcharts plugin for setting a lower opacity for other series than the
         * one that is hovered in the legend
         */
        var that = this;
      if (that.getURLParameter('m'))
      {
        selMats = that.getURLParameter('m').split(',');
        console.log('selMats', selMats);
      }
        (function (Highcharts)
        {
          var each = Highcharts.each;

          Highcharts.wrap(Highcharts.Legend.prototype, 'renderItem', function (proceed, item)
          {

            proceed.call(this, item);

            var isPoint = !!item.series, collection = isPoint ? item.series.points : this.chart.series, groups = isPoint ? ['graphic'] : ['group',
              'markerGroup'], element = (this.options.useHTML ? item.legendItem : item.legendGroup).element;

            element.onmouseover = function ()
            {
              each(collection, function (seriesItem)
              {
                if (seriesItem !== item)
                {
                  each(groups, function (group)
                  {
                    seriesItem[group].animate({
                      opacity: 0.05
                    }, {
                      duration: 150
                    });
                  });
                }
              });
            };
            element.onmouseout = function ()
            {
              each(collection, function (seriesItem)
              {
                if (seriesItem !== item)
                {
                  each(groups, function (group)
                  {
                    seriesItem[group].animate({
                      opacity: 1
                    }, {
                      duration: 50
                    });
                  });
                }
              });
            };

          });
        }(Highcharts));
        $('#linkedIcon, #vc_input_2 .tooltip').on('click', function (event)
        {
          linked = !linked;
          var fileName = linked ? 'linked' : 'unlinked';
          // $('#linkedIcon img').attr('src', 'images/' + fileName + '.png');
          if (linked) {
            $("#linkicon_linked").show();
            $("#linkicon_unlinked").hide();
            $( "#inputTemp" ).trigger( "change" );
          } else {
            $("#linkicon_unlinked").show();
            $("#linkicon_linked").hide();
          }
          // $('#linkedIcon img').attr('src', this.getImgUrl('link.png'));
        });
        $('#selectUnits').on('change', function (event)
        {
          that.convertValues();
          // drawChart();
        });
        $('#selectPipeMat').on('change', function (event)
        {
          selMats = $(this).val() == null ? [] : $(this).val();
          console.log("change mat", selMats);

          $("#upperSettingsBlock").empty();
          let selectedTexts = $('#selectPipeMat option:selected').text().toLowerCase();
          if (medium == "water") {
            if (selectedTexts.indexOf("wasser") > -1 || selectedTexts.indexOf("water") > -1) {
              $("#upperSettingsBlock").append("<div>" + that.getText('medium_water_hint_water') + "</div>");
            }
            if (selectedTexts.indexOf("gas") > -1) {
              $("#upperSettingsBlock").append("<div>" + that.getText('medium_water_hint_gas') + "</div>");
            }
          }
          if (medium == "industrial") {
            if (selectedTexts.indexOf("wasser") > -1 || selectedTexts.indexOf("water") > -1) {
              $("#upperSettingsBlock").append("<div>" + that.getText('medium_industrial_hint_water') + "</div>");
            }
          }
          that.drawChart();
          $( "#inputTemp" ).trigger( "change" );
        });
        $('#inputTemp, #inputPressure').on('change keyup', function (event)
        {
          let tmp = $("#main").css("margin-top");
          $("#main").css("margin-top", "0");
          that.generateGraphClick(event);
          $("#main").css("margin-top", tmp);
        });
        $('figure.effect-sadie').on('click', function (event)
        {
          event.preventDefault();
          medium = $(this).attr('data-selection');
          $('#app_header').text(that.getText('app_' + medium));
          $('#preselection').fadeOut(function ()
          {
            that.loadMediumData();
          });
        });
        $('.tooltip').on('click mouseenter', function (event)
        {
          $(this).find('.inner .close').toggle(event.type != 'mouseenter');
          $(this).find('.inner').fadeIn();
        });
        $('.tooltip').on('mouseleave', function (event)
        {
          event.stopPropagation();
          $(this).find('.inner').fadeOut();
        });
        $('.tooltip .inner').on('click', function (event)
        {
          event.stopPropagation();
          $(this).fadeOut();
        });
        $('.back_to_app_selection').on('click', function (event)
        {
          $('#wrapper').hide();
          $('#containerSW').empty();
          chart = null;
          medData = [];
          $('#preselection').fadeIn();
        });
        $('#printButton').on('click', function (event)
        {
          // if (ie <= 9)
          if(false)
          {
            var href = document.location.href;
            href = href.replace('app', 'index');
            var idx = href.indexOf('?');
            var link = idx == -1 ? href : href.substr(0, idx);
            link += '?u=' + $("#selectUnits :selected").val();
            link += '&t=' + $('#inputTemp').val();
            link += '&p=' + $('#inputPressure').val();
            link += '&m=' + $('#selectPipeMat').val();
            link += '&a=' + medium;
            link += '&d=' + duration;
            link += '&l=' + (linked ? '1' : '0');
            link += '&print=1';
            window.open(link, 'printWin', 'width=830, height=750, scrollbars=yes, resizable=no, directories=no, titlebar=no, toolbar=no, location=no, status=no, menubar=no');
          } else
            window.print();
        });
        $('#emailButton').on('click', function (event)
        {
          var link = 'mailto:?subject=' + escape(that.getText('email_subject'));
          link += '&body=' + escape(that.getText('email_body')) + '%0d%0a';
          // link += getText('email_baseurl');
          var href = document.location.href;
          href = href.replace('app', 'index');
          href = href.replace("#","");
          console.log("href", href);
          var idx = href.indexOf('?');
          link += idx == -1 ? href : href.substr(0, idx);
          link += '%3Fu=' + that.$refs.selectUnits.val();
          link += '%26t=' + $('#inputTemp').val();
          link += '%26p=' + $('#inputPressure').val();
          link += '%26m=' + $('#selectPipeMat').val();
          link += '%26a=' + medium;
          link += '%26d=' + duration;
          link += '%26l=' + (linked ? '1' : '0');
          link += '%26e=1';
          // console.log("email link", link);

          window.location = link;
        });
        $('#acceptButton').on('click', function (event)
        {
          $('#disclaimer').fadeOut(200, function ()
          {
            that.loadPipeData();
          });
        });
        if (this.getURLParameter('t'))
          $('#inputTemp').val(this.getURLParameter('t'));
        if (this.getURLParameter('p'))
          $('#inputPressure').val(this.getURLParameter('p'));
        // if (this.getURLParameter('u'))
        // {
        //   units = this.getURLParameter('u');
        //   console.log("UNITS###", units);
        //   that.$refs.selectUnits.setSelected(units);
        //   // $("#selectUnits").val(units);
        // }
        // if (this.getURLParameter('l'))
        // {
        //   linked = this.getURLParameter('l') == '1';
        //   var fileName = linked ? 'linked' : 'unlinked';
        //   $('#linkedIcon img').attr('src', 'images/' + fileName + '.png');
        // }
        if (this.getURLParameter('d'))
          duration = this.getURLParameter('d');
        $('#selectDuration').on('change', function (event)
        {
          duration = $(this).val();
          $('#containerSW').empty();
          chart = null;
          medData = [];
          that.loadMediumData();
        });
        // lang = this.getURLParameter('lang') == null ? window.getConfig("lang") : this.getURLParameter('lang');
      lang = window.mylang;
      if (window.mylang)
      {
        lang =window.mylang.substring(0,2);
      }
      this.loadTextData();

    },
    clickMedium: function (med) {

      var that = this;
      medium = med;
      linked = false;
      $("#linkicon_unlinked").show();
      $("#linkicon_linked").hide();
      console.log(medium);
      if (medium != "industrial") {
        duration = 50;
      } else {
        duration = 25;
      }
      $('#app_header').text(that.getText('app_' + medium));
      var yearsAr = [5, 10, 15, 25, 50];
      if (med === "industrial") {
        yearsAr = [5, 10, 15, 25];
      }
      var opts = [];
      $("#inputTemp").val("");
      $("#inputPressure").val("");
      for (var i = 0; i < yearsAr.length; i++)
      {
        opts.push({value:yearsAr[i], label:yearsAr[i] + ' ' + that.getText('years')});
      }
      that.$refs.selectDuration.setOptions(opts);
      that.$refs.selectDuration.setSelected(duration);
      firstStart = true;
      if ($('button.ui-multiselect').length > 0 ) {
        $('#selectPipeMat').multiselect('destroy').empty();
        // $('#selectPipeMat').multiselect('refresh');
      }
      $('#preselection').fadeOut(function ()
      {
        that.loadMediumData();
      });

    },
    selectDuration: function () {
      duration = this.$refs.selectDuration.val();
      $('#containerSW').empty();
      chart = null;
      console.log("select duration", medData);
      // medData = [];

      this.loadMediumData();
    },
    sortByKeyAsc: function (array, key) {
  return array.sort(function (a, b) {
    var x = a[key]; var y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
},
    loadPipeData: function () {

      var that = this;
      $.get(serverURL + 'data/pipe_materials.php?lang=' + lang, function (xml) {
        var $xml = $(xml);
        $xml.find('materialgroup').each(function (i, materialgroup) {
          $matGroup = $(materialgroup);
          var mats = [];
          $matGroup.find('material').each(function (i, material) {
            $mat = $(material);
            mats.push({
              groupID: $matGroup.attr('id'),
              matID: $mat.attr('id'),
              name: $mat.find('material_name').text(),
              color: '#' + $mat.find('material_color').text(),
              designfactor: $mat.find('material_designfactor').text()
            });
          });
          pData.push({
            matGroupID: $matGroup.attr('id'),
            matGroupName: $matGroup.find('materialgroup_name').text(),
            materials: mats
          });
        });
        if (that.getURLParameter('a'))
        {
          console.log("URLURL!!!!" );
          medium = that.getURLParameter('a');
          $('#app_header').text(that.getText('app_' + medium));
          that.loadMediumData();
        } else
        {
          $('#preselection').fadeIn(200);
        }
      });
    },
    loadMediumData: function () {
      console.log("loadMediumData",medData );
      var that = this;
      medData = [];
      duration = this.$refs.selectDuration.val();
      console.log("+++ duration",duration);
      if(typeof medium == "undefined") return;

      $.get(serverURL + 'data/graphs.php?dur=' + duration + '&app=' + medium +'&lang='+lang, function (xml) {
        var selectAll = !selMats;

        // if ($('button.ui-multiselect').length > 0 ) {
        //   $('#selectPipeMat').multiselect('destroy').empty();
        //   // $('#selectPipeMat').multiselect('refresh');
        // }

        var $xml = $(xml), cnt = 0;
        // if(!firstStart){
        //   that.drawChart();
        //   return;
        // }

  console.log("## firststart");
  $xml.find('materialgroup').each(function (i, materialgroup) {
    // console.log("selMats", selMats);
    $matGroup = $(materialgroup);
    var group = $('<optgroup>').attr('label', that.getPipeMatGroupName($matGroup.attr('id')));
    $matGroup.find('material').each(function (j, material) {
      $mat = $(material);
      var mData = {
        id: $mat.attr('id'),
        name: that.getPipeMat($matGroup.attr('id'), $mat.attr('id')).name,
        color: that.getPipeMat($matGroup.attr('id'), $mat.attr('id')).color,
        designfactor: that.getPipeMat($matGroup.attr('id'), $mat.attr('id')).designfactor,
        data: []
      };

      $mat.find('p').each(function (i, point) {
        $p = $(point);
        mData.data.push({
          x: parseInt($p.attr('temperature')),
          y: $p.attr('pressure') == '0' ? null : parseFloat($p.attr('pressure')),
          predotted: $p.attr('predotted') == 'true',
          dotted: $p.attr('dotted') == 'true'
        });
      });
      medData.push(mData);
      if (selectAll)
      {

        if (!selMats)
          selMats = [];
        selMats.push(mData.id);
      }

      group.append(that.createSelectOption(mData));

    });
     $('#selectPipeMat').append(group);
  });

          $('#selectPipeMat').multiselect({
            minWidth: 275,
            checkAllText: that.getText('select_all'),
            uncheckAllText: that.getText('deselect_all'),
            selectedText: function (selected) {
              return selected > 1 ? selected + ' ' + that.getText('materials_selected') : selected + ' ' +
                  that.getText('material_selected');
            },
            noneSelectedText:that.getText('none_selected_text'),
            open: function () {
              $('li.ui-multiselect-optgroup-label').on('click', function (event) {
                $('li.ui-multiselect-optgroup-label').off('click');
              });
              if (bTip)
                return;
              bTip = true;
              $('button.ui-multiselect').tooltipsy({
                className: 'bubbletooltip_tip',
                alignTo: "#selectPipeMat",
                offset: [$(window).width()>600?10:0, 1],
                content: that.getText('hint_multiselect'),
                show: function (e, $el) {
                  $el.fadeIn(100);
                },
                hide: function (e, $el) {
                  $el.fadeOut(1000);
                },
                showEvent: null,
                hideEvent: null
              });

              $('button.ui-multiselect').data('tooltipsy').show();

            },
            close: function () {
              if ($('button.ui-multiselect').data && $('button.ui-multiselect').data('tooltipsy'))
                $('button.ui-multiselect').data('tooltipsy').destroy();
            },
            click: function (event, ui) {
              if ($('button.ui-multiselect').data && $('button.ui-multiselect').data('tooltipsy'))
                $('button.ui-multiselect').data('tooltipsy').destroy();
            }
          });
          $('.optgroup-cb').on('click', function (event) {
            try
            {
              $(event.target).next('span').find('a').trigger('click.multiselect', true);
              $('button.ui-multiselect').data('tooltipsy').hide();
            } catch(e){}
          });



        // $(".optgroup-cb").click();

        $('button.ui-multiselect').css('width', '100%');
        if ($('button.ui-multiselect').length > 0 && firstStart) {
          $('#selectPipeMat').multiselect('uncheckAll');
          firstStart = false;
        }

        $('#wrapper').show();

        that.drawChart();

      });

    },
    generateGraphClick: function (event) {
      // console.log("generateGraphClick" );
      var cp;
      if (event && selMats.length == 1 && linked)
      {
        var s = chart.get('s_' + selMats[0]);
        // console.log("selMats",selMats);
        window.chart = chart;
        // var d = s.data, lower, upper, t, p, i;
        var d = s.linkedSeries[0].data, lower, upper, t, p, i;  //edit sw
        if (event.target == $('#inputTemp')[0])
        {
          t = parseFloat($('#inputTemp').val());
          for (i = 0; i < d.length; i++)
          {
            if (d[i].x >= t)
            {
              upper = d[i];
              break;
            }
            lower = d[i];
          }
          if (upper.y == null || lower.y == null)
          {
            cp = chart.get('clickPoint');
            if (cp)
              cp.remove();
            $('#inputPressure').val('');
            return;
          }
          p = lower.y + (upper.y - lower.y) / (upper.x - lower.x) * (t - lower.x);
          $('#inputPressure').val((p - .1).toFixed(1));
        } else
        {
          p = parseFloat($('#inputPressure').val());
          for (i = 0; i < d.length; i++)
          {
            if (d[i].y == null)
              continue;
            if (d[i].y <= p)
            {
              lower = d[i];
              break;
            }
            upper = d[i];
          }
          if (upper.y == null || lower.y == null || lower == undefined)
          {
            cp = chart.get('clickPoint');
            if (cp)
              cp.remove();
            $('#inputTemp').val('');
            return;
          }
          t = lower.x + (upper.x - lower.x) / (upper.y - lower.y) * (p - lower.y);
          $('#inputTemp').val((t - .1).toFixed(1));
        }
      }
      if ($('#inputTemp').val() == '' || $('#inputPressure').val() == '')
        return;
      cp = chart.get('clickPoint');
      if (cp)
        cp.remove();
      chart.addSeries({
        showInLegend: false,
        marker: {
          enabled: true,
          symbol: 'diamond',
          radius: 5,
          fillColor: '#ff0000'
        },
        data: [{
          x: parseFloat($('#inputTemp').val()),
          y: parseFloat($('#inputPressure').val())
        }],
        id: 'clickPoint',
        enableMouseTracking: false
      });
      cp = chart.get('clickPoint');
      cp.data[0].firePointEvent('click');
    },
    setClickMarker: function () {
      // console.log("setClickMarker" );

      var cp = chart.get('clickPoint');
      if (cp)
        cp.remove();
      chart.addSeries({
        showInLegend: false,
        marker: {
          enabled: true,
          symbol: 'diamond',
          radius: 5,
          fillColor: '#ff0000'
        },
        data: [{
          x: parseFloat($('#inputTemp').val()),
          y: parseFloat($('#inputPressure').val())
        }],
        id: 'clickPoint',
        enableMouseTracking: false
      });
      cp = chart.get('clickPoint');
      
      // $('g.highcharts-legend').attr('transform', 'translate(35,485)'); //change sw
      // $('div.highcharts-legend').css({top: 400, left: 380});
    },
    showHideSeries: function (x, y) {
      // console.log("showHideSeries" );
      var that = this;
      var shownGraphsCount = [];
      var cp = chart.get('clickPoint');
      if (cp)
        cp.remove();
      // console.log("selmats", selMats);
      if (that.detectIE())
      {
        var o = $('#containerSW').offset();
        var svg = document.getElementsByTagName('svg')[0];
        x = x - o.left;
        y = y - o.top;
        var rect = svg.createSVGRect();
        rect.x = x;
        rect.y = y;
        rect.width = 1;
        rect.height = 1;
        var nodeList = svg.getIntersectionList(rect, null);
        $('g.highcharts-series-group').find('g.highcharts-series').each(function (i, el) {
          try
          {
            // s.hide();
            $(el).find('path').attr('opacity', '.15');
            var id = $($(el).closest('g')).attr('id');
            $('#li_' + id).attr('opacity', '.15');
          } catch (e)
          {
            //console.log('error', e);
            //console.log('fehler serie', s);
            // TODO: handle exception
          }
        });
        for (var i = 0; i < nodeList.length; i++)
        {
          var item = nodeList[i];
          var id = $($(item).closest('g')).attr('id');
          if (id != undefined)
          {
            var s = chart.get(id);
            if (!s || s.isXAxis)
              return true;
            if ($.inArray(s.name, shownGraphsCount) == -1)
              shownGraphsCount.push(s.name);
            s.show();
            $(item).closest('g').find('path').removeAttr('opacity');
            $('#li_' + id).removeAttr('opacity');
            if (id.indexOf('_dotted') > 0)
            {
              s = chart.get(id.substr(0, id.length - 7));
              s.show();
            }
          }
        }
      } else
      {
        $('g.highcharts-tooltip').attr('visibility', 'hidden');
        $('g.highcharts-series-group g.highcharts-series').attr('visibility', 'visible');
        $('g.highcharts-series-group g.highcharts-series path').css('display', 'none');
        let hideElements = selMats;
        $('g.highcharts-series-group').find('g.highcharts-series').each(function (i, el) {
          $(el).find('path').first().css('display', 'block').css('pointer-events', 'all');
          var id = $($(el).closest('g')).attr('id');
          var s = chart.get(id);
          if (!s || s.isXAxis)
            return true;

          (function() {
            'use strict';
            var api;
            api = function(x,y) {
              var elm, scrollX, scrollY, newX, newY;
              /* stash current Window Scroll */
              scrollX = window.pageXOffset;
              scrollY = window.pageYOffset;
              /* scroll to element */
              window.scrollTo(x,y);
              /* calculate new relative element coordinates */
              newX = x - window.pageXOffset;
              newY = y - window.pageYOffset;
              /* grab the element */
              elm = this.elementFromPoint(newX,newY);
              /* revert to the previous scroll location */

              window.scrollTo(scrollX,scrollY);
              /* returned the grabbed element at the absolute coordinates */
              return elm;
            };
            window.document.elementFromAbsolutePoint = api;
          }).call(this);

          var offset = 0;

          if($("body").width() > 767) {
            $("header").hide();
          }
          if (document.elementFromAbsolutePoint(x, y+offset) == $(el).find('path').first()[0])
          {
            if ($.inArray(s.name, shownGraphsCount) == -1)
              shownGraphsCount.push(s.name);
            s.show();

            if (id.indexOf('_dotted') > 0)
            {
              s = chart.get(id.substr(0, id.length - 7));
              s.show();
            }
            let tmpid = id.substring(2);
            if (tmpid.indexOf('_dotted') > 0)
            {
              tmpid = tmpid.substring(0, tmpid.indexOf('_dotted'));
            }
            if (tmpid.indexOf('_predotted') > 0)
            {
              tmpid = tmpid.substring(0, tmpid.indexOf('_predotted'));
            }
            hideElements = jQuery.grep(hideElements, function(value) {
              return (value != tmpid && value != tmpid+"_dotted" && value != tmpid+"_predotted");
            });
            $("#s_" + tmpid).find('path').removeAttr('opacity');
            $("#s_" + tmpid+"_dotted").find('path').removeAttr('opacity');
            $("#s_" + tmpid+"_predotted").find('path').removeAttr('opacity');
            $('#li_s_' + tmpid).removeAttr('opacity');
            // hideElements = jQuery.grep(hideElements, function(value) {
            //   return value != tmpid+"_dotted";
            // });
            // hideElements = jQuery.grep(hideElements, function(value) {
            //   return value != tmpid+"_predotted";
            // });
          }

          $(el).find('path').first().css('display', 'none');
        });
        // console.log("##hideElements", hideElements);
        for (let i = 0; i < hideElements.length; ++i) {
          $("#s_"+hideElements[i]).find('path').attr('opacity', '.15'); //edit
          $("#s_"+hideElements[i]+"_dotted").find('path').attr('opacity', '.15'); //edit
          $("#s_"+hideElements[i]+"_predotted").find('path').attr('opacity', '.15'); //edit
          $('#li_s_' + hideElements[i]).attr('opacity', '.15');
        }
        $("header").show();
      }
      $('g.highcharts-series-group g.highcharts-series path').removeAttr('style');
      $('g.highcharts-tooltip').attr('visibility', 'visible');
      $('#hint_graphs').hide();
      if (shownGraphsCount.length == 0)
      {
        $('#hint_graphs').show();
      } else if (shownGraphsCount.length == 1)
      {
        var mat = that.getPipeMatByName(shownGraphsCount[0]);
        $('input[name=inputDF]').val(mat.designfactor);
      } else
        $('input[name=inputDF]').val(that.getText('hint_design_factor'));
    },
    createSelectOption: function (mData) {
      //console.log("createSelectOption" );
      var opt = $('<option>');
      opt.text(mData.name).attr('value', mData.id);
      if ($.inArray(mData.id, selMats) > -1)
        opt.attr('selected', true);

      return opt;
    },
    getImgUrl:function(pic) {
      return require('../assets/'+pic)
    },
    convertValues: function () {
      var that = this;
      //console.log("convertValues" );
      // var metric = $("#selectUnits :selected").val() == 'metric';
      var metric = that.$refs.selectUnits.val() == 'metric';
      if ((units == 'metric' && metric) || units != 'metric' && !metric)
        return;

      var max = 0;
      for (var i = 0; i < chart.series.length; i++)
      {
        for (var j = 0; j < chart.series[i].data.length; j++)
        {
          var point = chart.series[i].data[j];
          var test = test = metric ? that.psiToBar(point.y) : that.barToPsi(point.y);

          if(test > max) max = test;
        }
      }

      if (metric)
      {
        options.xAxis.title.text = 'T [°C]';
        options.xAxis.min = -50;
        options.xAxis.max = 140;
        options.xAxis.labels.step = 1;
        options.yAxis.title.text = 'P [bar]';
        options.yAxis.title.y = -10;
        options.yAxis.min = 0;
        options.yAxis.max = max+1;
        options.yAxis.minorTickInterval = 1;
        options.yAxis.tickInterval = 2;
        $('#temperature').text(that.getText('temperature') + ' [°C]');
        $('#pressure').text(that.getText('pressure') + ' [bar]');
      } else
      {
        options.xAxis.title.text = 'T [°F]';
        options.xAxis.min = that.celsiusToFahrenheit(-50);
        options.xAxis.max = that.celsiusToFahrenheit(140);
        options.xAxis.labels.step = 2;
        options.yAxis.title.text = 'P [psi]';
        options.yAxis.title.y = -10;
        options.yAxis.min = 0;
        options.yAxis.max = max+1;
        options.yAxis.minorTickInterval = 10;
        options.yAxis.tickInterval = 20;
        $('#temperature').text(that.getText('temperature') + ' [°F]');
        $('#pressure').text(that.getText('pressure') + ' [psi]');
      }
      chart.xAxis[0].update(options.xAxis, false);
      chart.yAxis[0].update(options.yAxis, false);
      for (var i = 0; i < chart.series.length; i++)
      {
        for (var j = 0; j < chart.series[i].data.length; j++)
        {
          var point = chart.series[i].data[j];
          point.update({
            x: metric ? that.fahrenheitToCelsius(point.x) : that.celsiusToFahrenheit(point.x),
            y: metric ? that.psiToBar(point.y) :that.barToPsi(point.y)
          }, false);
        }
      }
      chart.redraw();
      if ($('#inputTemp').val() != '')
      {
        $('#inputTemp').val(metric ? that.fahrenheitToCelsius(parseFloat($('#inputTemp').val()))
            .toFixed(1) : that.celsiusToFahrenheit(parseFloat($('#inputTemp').val())).toFixed(1));
      }
      if ($('#inputPressure').val() != '')
      {
        $('#inputPressure').val(metric ? that.psiToBar(parseFloat($('#inputPressure').val()))
            .toFixed(1) : that.barToPsi(parseFloat($('#inputPressure').val())).toFixed(1));
      }
      $('#inputTemp').attr('min', chart.xAxis[0].min);
      $('#inputTemp').attr('max', chart.xAxis[0].max);
      $('#inputPressure').attr('min', chart.yAxis[0].min);
      $('#inputPressure').attr('max', chart.yAxis[0].max);
      // units = $("#selectUnits :selected").val();
      units = that.$refs.selectUnits.val();
    },
    drawChart: function () {
      //console.log("drawChart" );
      var that = this;
      var metric = that.$refs.selectUnits.val() == 'metric';
      options.series = [];
      if (metric)
      {
        options.xAxis.title.text = 'T [°C]';
        options.xAxis.min = -50;
        options.xAxis.max = 140;
        options.xAxis.labels.step = 1;
        options.yAxis.title.text = 'P [bar]';
        options.yAxis.title.style.textTransform = 'none';
        options.yAxis.min = 0;
        options.yAxis.max = 25;
        options.yAxis.minorTickInterval = 1;
        options.yAxis.tickInterval = 2;
      } else
      {
        options.xAxis.title.text = 'T [°F]';
        options.xAxis.min = that.celsiusToFahrenheit(-50);
        options.xAxis.max = that.celsiusToFahrenheit(140);
        options.xAxis.labels.step = 2;
        options.yAxis.title.text = 'P [psi]';
        options.yAxis.min = 0;
        options.yAxis.max = that.barToPsi(25);
        options.yAxis.minorTickInterval = 10;
        options.yAxis.tickInterval = 20;
      }
      if (selMats.length == 1)
      {
        var mat = that.getPipeMatById(selMats[0]);
        $('input[name=inputDF]').val(mat.designfactor);
      } else
        $('input[name=inputDF]').val(that.getText('hint_design_factor'));
      var max = 0;
      for (var i = 0; i < medData.length; i++)
      {
        if ($.inArray(medData[i].id, selMats) > -1)
        {
          var dotted = false;
          var seriesOptions = {
            id: 's_' + medData[i].id,
            name: medData[i].name,
            data: [],
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              }
            },
            color: medData[i].color
          };
          var seriesOptionsPreDotted = {
            id: 's_' + medData[i].id,
            name: medData[i].name,
            data: [],
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              }
            },
            color: medData[i].color
          };
          var seriesOptionsDotted = {
            id: 's_' + medData[i].id,
            name: medData[i].name,
            data: [],
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              }
            },
            color: medData[i].color
          };
          var isPredotted = false;

          seriesOptionsPreDotted.id = 's_' + medData[i].id + '_predotted';
          seriesOptionsPreDotted.dashStyle = 'shortdash';
          seriesOptionsPreDotted.linkedTo = 's_' + medData[i].id;

          seriesOptionsDotted.id = 's_' + medData[i].id + '_dotted';
          seriesOptionsDotted.dashStyle = 'shortdash';
          seriesOptionsDotted.linkedTo = 's_' + medData[i].id;
          for (var j = 0; j < medData[i].data.length; j++)
          {
            var data = {
              x: metric ? medData[i].data[j].x : that.celsiusToFahrenheit(medData[i].data[j].x),
              y: metric ? medData[i].data[j].y : that.barToPsi(medData[i].data[j].y)
            };
            var test = metric ? (medData[i].data[j].y) : that.psiToBar(medData[i].data[j].y) ;
            if(test > max) max = test;
            if (!dotted) {
              seriesOptions.data.push(data);
            }

            seriesOptionsPreDotted.data.push(data);

            if (medData[i].data[j].predotted) {
              seriesOptions.data = [];
              seriesOptions.data.push(data);
            }
            if (medData[i].data[j].dotted) {
              dotted = true;
              seriesOptionsDotted.data.push(data);
            }
          }
          // options.series.push(seriesOptions);
          options.series.push(seriesOptions);
          options.series.push(seriesOptionsPreDotted);
          options.series.push(seriesOptionsDotted);
        }
      }
      options.yAxis.max = max+1;
      if (options.series.length == 0)
        options.series.push({
          data: [],
          showInLegend: false
        });
      $('.highcharts-container').css('overflow', options.series.length == 0 ? 'hidden' : 'visible');
      chart = new Highcharts.Chart(options);
      var serObj = $('g.highcharts-series-group g.highcharts-series');
      var arSer = $.makeArray(serObj);
      var legObj = $('g.highcharts-legend g.highcharts-legend-item');
      var arLeg = $.makeArray(legObj);
      var cnt = 0;
      for (var i = 0; i < chart.series.length; i++)
      {
        var s = chart.series[i];
        $(arSer[i]).attr('id', s.options.id);
        try
        {


          if (s.options.id.indexOf('dotted') == -1)
          {
            $(arLeg[cnt++]).attr('id', 'li_' + s.options.id);
          }
        } catch (e){};
      }
      iid = setTimeout(function () {
        $('text.highcharts-yaxis-title').attr('transform', 'translate(0,-10)');
        // $('g.highcharts-legend').attr('transform', 'translate(35,0)'); //change sw
        // $('div.highcharts-legend').css({top: 400, left:
        // 380}).hide().fadeIn();
        // let tmp = $("#main").css("margin-top"); //edit sw
        // $("#main").css("margin-top", "0");
        // that.generateGraphClick();
        // $("#main").css("margin-top", tmp);
        $( "#inputTemp" ).trigger( "change" );
        if (that.getURLParameter('print'))
        {
          $('#emailButton, #printButton').remove();
          window.print();
          window.close();
        }
      }, 250);

      that.setClickMarker();
    },
    celsiusToFahrenheit: function (degrees) {
      return ((degrees * 9) / 5) + 32;
    },
    fahrenheitToCelsius: function (degrees) {
      return ((degrees - 32) * 5) / 9;
    },
    barToPsi: function (bar) {
      return bar == null ? null : bar * 14.5037738;
    },
    psiToBar: function (psi) {
      return psi == null ? null : psi / 14.5037738;
    },
    getPipeMatByName: function (name) {
      for (var i = 0; i < medData.length; i++)
      {
        var p = medData[i];
        if (p.name == name)
          return p;
      }
      return 'name not found';
    },
    getPipeMatById: function (id) {
      for (var i = 0; i < medData.length; i++)
      {
        var p = medData[i];
        if (p.id == id)
          return p;
      }
      return 'name not found';
    },
    getPipeMatGroupName: function (groupID) {
      for (var i = 0; i < pData.length; i++)
      {
        var p = pData[i];
        if (p.matGroupID == groupID)
          return p.matGroupName;
      }
      return 'name not found';
    },
    getPipeMat: function (groupID, matID) {
      for (var i = 0; i < pData.length; i++)
      {
        var p = pData[i];
        for (var j = 0; j < p.materials.length; j++)
        {
          var mat = p.materials[j];
          if (mat.groupID == groupID && mat.matID == matID)
            return mat;
        }
      }
      return {
        name: 'material not found',
        color: '#dddddd'
      };
    },
    getGridTopLeft: function () {
      var gridLines = $('.highcharts-grid').find('path');
      var minX = 1000, minY = 1000, coords;
      for (var i = 0; i < gridLines.length; i++)
      {
        coords = ($(gridLines[i]).attr('d')).split(' ');
        minX = Math.min(minX, parseFloat(coords[1]));
        minY = Math.min(minY, parseFloat(coords[2]));
      }
      return {
        x: minX,
        y: minY
      };
    },
    getURLParameter: function (name) {
      // console.log("getURLParameter",decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.search) ||
      //     [, ""])[1].replace(/\+/g, '%20')) || null );
      // return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.search) ||
      //     [, ""])[1].replace(/\+/g, '%20')) || null;
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
      for (i = 0; i < sURLVariables.length; i++)
      {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === name)
        {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
      return null;
    },
    asyncContent: function () {
      return this.getText('hint_units');
    },
    getText: function (id) {
      if(typeof $texts == "undefined") return "lulu";
      return $texts.find(id).text();
    },
    detectIE: function () {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0)
      {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0)
      {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0)
      {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    },
    getConfig:function (key)
    {
      for (var i = 0; i < $(".gfPtToolVue3 app").data("config")["props"].length; ++i)
      {
        if (JSON.parse($(".gfPtToolVue3 app").data("config")["props"][i])["key"] == key)
        {
          return JSON.parse($(".gfPtToolVue3 app").data("config")["props"][i])["value"];
        }
      }
    }


  }// end methods
}
</script>
<style>
@import  "../../src/assets/css/set1.css";
@import  "../../src/assets/css/jquery-ui.css";
@import  "../../src/assets/css/jquery-ui2.css";
@import  "../../src/assets/css/jquery.multiselect.css";
@import  "../../src/assets/css/jquery.multiselect.filter.css";

</style>
<style scoped>

@font-face {
  font-family: "DINNextLTW05-Regular";
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix");
  src: url("../assets/DINNextLTW05-Regular.eot?#iefix") format("eot"),
  url("../assets/DINNextLTW05-Regular.woff2") format("woff2"),
  url("../assets/DINNextLTW05-Regular.woff") format("woff"),
  url("../assets/DINNextLTW05-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "GlyphaLTW05-65Bold";
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix");
  src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix") format("eot"),
  url("../assets/GlyphaLTW05-65Bold.woff2") format("woff2"),
  url("../assets/GlyphaLTW05-65Bold.woff") format("woff"),
  url("../assets/GlyphaLTW05-65Bold.ttf") format("truetype");
}

@font-face {
  font-family: "DINNextLTW01-Medium";
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix");
  src: url("../assets/DINNextLTW01-Medium.eot?#iefix") format("eot"),
  url("../assets/DINNextLTW01-Medium.woff2") format("woff2"),
  url("../assets/DINNextLTW01-Medium.woff") format("woff"),
  url("../assets/DINNextLTW01-Medium.ttf") format("truetype");
}



#preselection, #wrapper,#hint_graphs {
  display:none;
}
#preselection {
  cursor: pointer;
}
#wrapper, #disclaimer, #preselection {
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;

  /*padding: 20px;*/
  padding-bottom: 30px;
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
}
.innerWrapper {
  padding: 20px;
  border: 1px solid #ccc;
  padding-top:0;
}
#disclaimer, #preselection {
  border:0
}
#wrapper h2 {
  font-size: 36px;
  color: #0065A7;
}
#linkedIcon {
   position: absolute;
   right: -8px;
   top:60px;
   cursor: pointer;
   /*z-index: -1;*/
 }
#containerSW {
  width:98%;
}
#upperSettingsBlock {
  margin-top:10px;
}
.halfRow {
  width: 31%;
  display: inline;
  float: left;
  margin-right:1.5%;
}
.myblock {
  display: inline;
  float: left;
  width: 99%;
  margin-top:32px;
}
.myLabel {
  font-size: 16px;
  text-align: left;
}
.preselectBox {
  margin:24px;
  cursor: pointer;
}
.preselectBox p {
  line-height: normal !important;
}
.preselectBox h2 {
  color: #0065A7;
  font-size: 24px;
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
  line-height: unset;
  font-weight: 700;
  margin-bottom:10px;
}
#preselection img {
  width:100%
}
#preselection .halfRow {
  margin-right: 0;
  width: 31%;
  margin-right:1%
}
.infoI {
  background: url(../assets/infoI.png) no-repeat;
  bottom: 1px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  z-index: 1000;
  vertical-align: sub;
  float: right;
  margin-top: 0px;
}
.clearfix {
  clear: both;
}
select,
input {
  -webkit-font-smoothing: antialiased;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  background-color: #f0f0f0;
  border: 0.1875rem solid #f0f0f0;
  border-radius: 0;
  display: block;
  font-family: DINNextLTW05-Regular, sans-serif;
  font-size: 1rem;
  /* font-size: 12px; */
  height: 2.5rem;
  padding: 0.3125rem 2.375rem 0.3125rem calc(0.1875rem + 0.3125rem);
  width: 100%;
  outline: none;
}
.selectWrapper, .inputWrapper {
  color: #000;
  font-family: "DINNextLTW05-Regular", sans-serif;
  font-size: 16px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  flex-basis: 100%;
  margin-top: 8px;
  position: relative;
}
#acceptButton {
  float: left;
  color: #fff;
  font-size: 1.125rem;
  font-family: DINNextLTW05-Regular,Arial,sans-serif;
  height: 60px;
  margin: 20px 5px 0 0;
  background: 7px 7px no-repeat #f60;
  border: none;
  padding: 0 20px 0 20px;
  cursor: pointer;
}
.continueButton {
  float: left;
  color: #fff;
  font-size: 1.125rem;
  font-family: DINNextLTW05-Regular,Arial,sans-serif;
  /*height: 60px;*/
  margin: 14px 5px 0 0;
  background: 7px 7px no-repeat #f60;
  border: none;
  padding: 10px 20px 10px 20px;
}
.back_to_app_selection {
border: 2px solid #00AFFF;
  color:#00AFFF;
  padding:14px 24px;
  float: right;
  /*margin-top:24px;*/
  /*margin-right: 10px;*/
  cursor: pointer;
}
#buttonBox {
  border-bottom: 1px solid #ccc;
  margin-top:20px;
  margin-bottom: 20px;
  margin-left:-20px;
  margin-right:-20px;
  padding-left: 20px;
  padding-bottom:30px;
}
#emailButton:before {
  content: url("../assets/email.png");
  margin-right: 8px;
  vertical-align: middle;
}
#emailButton {
  color: #00abfe;
  font-size: 16px;
  cursor: pointer;
  font-family: "DINNextLTW01-Medium", Arial;
}
#printButton {
  color: #00abfe;
  font-size: 16px;
  cursor: pointer;
  margin-right: 35px;
  margin-left: 8px;
  font-family: "DINNextLTW01-Medium", Arial;
}
#printButton:before {
  content: url("../assets/print.png");
  margin-right: 8px;
  vertical-align: middle;
}
.arrow {
  float: left;
  margin-top: 18px;
}

#back_to_app_selection_mobile {
  display: none;
}


@media screen and (max-width:670px) {
  .main {
    width:92%;
    margin: 0;
    /*padding:2px;*/
  }
  .halfRow {
    width:99%;
  }
  #preselection .halfRow {
    width: 99%;
    margin-bottom: 60px;
  }
  .row3 {
    width: 100%;
  }
  #toolInputs, #vc {
    width: unset;
  }
  .performancedata {
    margin-top:20px;
  }
  .preselectBox {
    margin: 0;
  }
  #wrapper, #disclaimer, #preselection {
    width: 95vw;
    border: 0;
    padding: 0px;
  }
  #back_to_app_selection {
    display: none;
  }
  #back_to_app_selection_mobile {
    display: block;
    float: none;
    text-align: center;
    margin-bottom: 20px;
    /*width: 97vw;*/
  }
  .innerWrapper {
    border-left:0;
    border-right:0;
  }
  #containerSW {
    /*height: 600px;*/
  }
}
</style>
<style>
body {
  margin: 0;
}
.highcharts-legend-item::before {
  content: url("../assets/legentitem.png");
  width:60px;
  height:40px;
  z-index: 999;
}
/*multiselect*/
.ui-multiselect {
  margin-top: 7px;
}
.ui-multiselect,
.ui-multiselect-menu {
  font-size: 13px;
}
.ui-multiselect-menu {
  width:unset!important;
}
input[type=checkbox] {
  opacity:0;
}
.ui-multiselect-menu .ui-widget .ui-widget-content .ui-corner-all {
  height:300px;
}
.ui-multiselect-checkboxes li label input[type="checkbox"]+span::before {
  width: 20px;
  height: 20px;
  background-image: url("../assets/css/images/checkbox.png");
  display: block;
  content: "";
  float: left;
  margin-right: 5px;
}
.ui-multiselect-checkboxes li label input[type="checkbox"]:checked+span::before {
  background-image: url("../assets/css/images/checkbox_checked.png");
}
.ui-multiselect.select-materials,
.ui-multiselect-menu.select-materials {
  width: 200px;
}
.select-media-dropdown > div > ul > li:nth-child(2) > a {
  line-height: 18px;
  color:#00ABFE;
}
.select-media-dropdown .ui-helper-reset,
.select-materials-dropdown .ui-helper-reset {
  position: relative;
}
.select-media-dropdown .ui-multiselect-close,
.select-materials-dropdown .ui-multiselect-close {
  position: absolute;
  top: 2px;
  right: 0;
}
.ui-icon-triangle-1-s {
  top: 12px;
}


/*tooltipsy*/
.bubbletooltip_tip {
  padding: 10px;
  color: #fff;
  background-color: #005499;
  -moz-box-shadow: inset 0 0 10px #005499;
  -webkit-box-shadow: inset 0 0 10px #005499;
  box-shadow: inset 0 0 10px #005499;
  text-shadow: 0 0 3px #005499;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  position: relative;
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
}
.bubbletooltip_tip:after {
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  border-color: transparent transparent #005499;
  border-style: solid;
  border-width: 31px;
  bottom: 14px;
  content: "";
  left: -29px;
  position: absolute;
  z-index: -1;
}

/*tooltip*/
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #fff;
  color: #000;
  border-radius: 0;
  border:#999 1px solid;
  font-family: "DINNextLTW05-Regular", Arial, sans-serif;
  font-size: 13px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #fff;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
#app_water_sub span, #app_gas_sub span, #app_industrial_sub span {
  font-size: 16px !important;
  font-weight: normal !important;
}
#app svg {
  pointer-events: unset;
}
@page
{
  size:  A4;
  margin: 0;
}
@media print {
  html {
    overflow: unset;
  }
  @page {size: landscape}
  #wrapper {
    /*width: 97% !important;*/
    width:10000px !important;;
    margin: 16px !important;
  }
  .highcharts-container {
    width: 100% !important;
    /*width: 1213px !important;*/
  }
  #text {
    display:none;
  }
  svg {
    width: 100% !important;
  }
}
</style>